// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ogPQJ","questions":"styles_questions__2Rxry","footer":"styles_footer__3aGim"};